import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserStoryService {
  constructor(private api: ApiService) {}

  getAllUserStories(data: any): Observable<any> {
    return this.api.post(environment.getAllUserStories, data);
  }

  createUserStory(data: any): Observable<any> {
    return this.api.post(environment.createUserStory, data);
  }

  updateUserStory(data: any): Observable<any> {
    return this.api.post(environment.updateUserStory, data);
  }

  deleteUserStory(data: any): Observable<any> {
    return this.api.post(environment.deleteUserStory, data);
  }

  getUserStoryById(data: any): Observable<any> {
    return this.api.post(environment.getUserStoryById, data);
  }
}
